import { render, staticRenderFns } from "./SelectPrices.vue?vue&type=template&id=7e4693cb"
import script from "./SelectPrices.vue?vue&type=script&lang=js"
export * from "./SelectPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports